import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  email: null, // Keep null for consistency
};

const signupUserSlice = createSlice({
  name: "signupUserSlice",
  initialState,
  reducers: {
    setsignupUser: (state, action) => {
      state.email = action.payload;
    },

    resetsignup: (state) => {
      state.email = null; 
    },
  },
});

export const { setsignupUser, resetsignup } = signupUserSlice.actions;
export default signupUserSlice.reducer;
